/* eslint-disable indent */

/* Example Usage:

const modalHtml = new ModalHtml(
    '<p>Lorem ipsum</p>',
    {
        visible: true,
        buttons: [
            {
                type: 'primary',
                text: 'Button Text',
            },
        ],
    },
);

console.log('modalHtml', modalHtml.toString());

*/

export default class ModalHtml {
    constructor(content, config) {
        this._content = content;
        this._config = config || {};
    }

    toString() {
        return `
        <div class="rfct-modal${this._config.visible ? ' rfct-modal--visible' : ''}${this._config.large ? ' rfct-modal--large' : ''}${this._config.cssClass ? ` ${this._config.cssClass}` : ''}">
            <div class="rfct-modal__inner">
                <button class="rfct-modal__close-button">
                    <span class="rfct-modal__close-icon material-icons">close</span>
                </button>
                <div class="rfct-modal__content-wrapper">
                    <div class="rfct-modal__content">
                        ${this._content || ''}
                    </div>
                    ${this._config && this._config.buttons && this._config.buttons.length ? `
                    <div class="rfct-modal__button-container">
                        ${
                            this._config.buttons.map((button) => `
                            <button class="rfct-button rfct-button--${button.type}">
                                <span class="rfct-button__inner">
                                    ${button.text}
                                </span>
                            </button>`).join('')
                        }
                    </div>
                ` : ''}
                </div>
            </div>
        </div>`;
    }
}
